import { createSelector } from "@ngrx/store";
import { IAppEsState } from "@edp-store/state/ES/app-es.state";
import { IProductEsState } from "@edp-store/state/ES/product-es.state";

const additionalProductEsSelector = (state: IAppEsState) => state.productEs;

export const getAdditionalProductEs = createSelector(additionalProductEsSelector, (state: IProductEsState) => state.additionalProduct);
